import { faLock } from '@fortawesome/pro-light-svg-icons';
import React, { memo } from 'react';

import Icon from '../../../../components/Icon';
import SquarePicture from '../../../../components/SquarePicture';
import FSK18 from '../../../../assets/images/icons/fsk18.png';
import ResourceService from 'services/i18n';
import useTranslation from 'services/i18n/core/useTranslation';
import NewsFeedUserStatItem from 'pages/Mainpage/NewsFeed/NewsFeedUserStatItem';
import { Button } from '@mui/material';

export interface IStrangerPictureComponentProps {
    strangerPicture: string;
    coins: number | undefined;
    index: number;
    onClick(key: number): void;
}

export const StrangerPictureComponent = memo((props: IStrangerPictureComponentProps) => {
    const { coins = 0, strangerPicture, onClick, index } = props;
    const { UNLOCK_IMAGE_BUTTON, DISCOVER } = useTranslation();

    return (
<SquarePicture onClick={onClick} index={index} src={strangerPicture}>
    {coins > 0 && (
        <div className="flex column centered full-height">
            <img style={{ width: 80 }} src={FSK18} />
           {/* @ts-ignore */}
            <Button size="small" fullWidth className="spacing triple margin" onClick={null}>
                {DISCOVER}
            </Button>
        </div>
    )}
</SquarePicture>
    );
});

export default StrangerPictureComponent;
